import React from "react";
export default function BCList() {
  return <div style={{ padding: 32 }}>This is Berita Acara page.</div>;
}
